<template>
  <v-card class="app-center">
    <v-toolbar
      color="error"
      cards
      dark
      flat
      height="70px">

      <v-card-title class="title font-weight-regular">Are you sure?</v-card-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-text>
      The record will be permanently deleted...
    </v-card-text>

    <v-card-actions>
      <v-btn small flat router-link to="/address-book">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn small color="error" @click="deleteRecord(id)">Delete</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>

export default {
  data () {
    return {
      //
    }
  },
  props: ['id'],
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    deleteRecord () {
      this.$store.dispatch('deleteAddress', { user_id: this.user.id, address_id: this.id })
    }
  }
}

</script>
